import { maintenanceConstants } from "./maintenance.constants"


export interface MaintenanceState {
  loading: boolean
  roomTypes: any[]
  categoryTypes: any[]
  flowList: any[]
  flowListTotalCount: number
  issuesList: any[]
  issuesListTotalCount: number
  projectList: any[]
  projectListTotalCount: number
  error?: string
  projecIssuetList?: any
}

const initialState: MaintenanceState = {
  loading: false,
  roomTypes: [],
  categoryTypes: [],
  flowList: [],
  flowListTotalCount: 0,
  issuesList: [],
  issuesListTotalCount: 0,
  projectList: [],
  projectListTotalCount: 0,
  projecIssuetList: null
}

export function maintenance(
  state = initialState,
  action: any
): MaintenanceState {
  switch (action.type) {

    case maintenanceConstants.SET_LOADING:
      return { ...state, loading: action.payload }

    case maintenanceConstants.GET_ROOM_TYPES_SUCCESS:
      return { ...state, roomTypes: action.data }

    case maintenanceConstants.GET_CATEGORY_TYPES_SUCCESS:
      return { ...state, categoryTypes: action.data }

    case maintenanceConstants.GET_FLOWS_SUCCESS:
      return {
        ...state,
        flowList: action.data.data,
        flowListTotalCount: action.data.count,
      }

    case maintenanceConstants.GET_ISSUES_SUCCESS:
      return {
        ...state,
        issuesList: action.data.data,
        issuesListTotalCount: action.data.count,
      }

    case maintenanceConstants.GET_PROJECTS_SUCCESS:
      return {
        ...state,
        projectList: action.data.data,
        projectListTotalCount: action.data.count,
        projecIssuetList: null
      }
    case maintenanceConstants.GET_PROJECTS_I_SUCCESS:
      return {
        ...state,
        projecIssuetList: action?.data?.data,

      }
    case maintenanceConstants.GET_FLOWS_FAILURE:
    case maintenanceConstants.GET_ROOM_TYPES_FAILURE:
    case maintenanceConstants.GET_CATEGORY_TYPES_FAILURE:
    case maintenanceConstants.GET_PROJECTS_FAILURE:
    case maintenanceConstants.GET_ISSUES_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      }

    default:
      return state
  }
}
